import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  useSearchParams,
} from "react-router-dom";
import IntervalService from './../../services/intervals';
import TR from './../../Trans';
import muvikaAttrs from './../../attrs';
import { Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import ExternalViewCommands from './../../services/external';
import MediaQuery from 'react-responsive';
import Landscape from './Landscape';
import { setSafeAreas } from './../../services/safeareas';
import Error from './../items/Error';
import Message from './../items/Message';
import Portrait from './Portrait';
import SongbookWelcome from '../dialogs/SongbookWelcome';
import { generateId } from './../../services/random';
import MuvikaService from './../../services/muvika';
import navigationStore from '../../stores/navigation';
import songbookSessionStore from './../../stores/songbookSession';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import homeStore from '../../stores/home';
import songListStore from '../../stores/songList';
import timeoutsStore from '../../stores/timeouts';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import SongbookLandscape from './SongbookLandscape';
import SongbookPortrait from './SongbookPortrait';
import bgFiltersStore from '../../stores/bgFilters';
import bgPlaylistsStore from '../../stores/bgPlaylists';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgStylesStore from '../../stores/bgStyles';
import bgSearchStore from '../../stores/bgSearch';
import { useLocalStorage } from '../../services/useLocalStorage';
import songbookQueueStore from '../../stores/songbookQueue';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const songbookIntervalTime = 10000;

function SongbookApp() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const [queryParameters] = useSearchParams();

  const session = songbookSessionStore((state) => state.session);
  const updateSession = songbookSessionStore((state) => state.updateSession);
  const isSongbookPublicMode = songbookSessionStore((state) => state.isSongbookPublicMode);
  const isSongbookPublicBoothMode = songbookSessionStore((state) => state.isSongbookPublicBoothMode);
  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const isSessionOpen = songbookSessionStore((state) => state.isSessionOpen);
  const isLoggedIn = songbookSessionStore((state) => state.isLoggedIn);
  const account = accountStore((state) => state.account);
  const clearError = messageStore((state) => state.clearError);
  const playQueue = performanceStore((state) => state.playQueue);
  const getPlayQueue = performanceStore((state) => state.getPlayQueue);
  const getMySongRequestsDelivered = performanceStore((state) => state.getMySongRequestsDelivered);
  const getMySongRequestsPending = performanceStore((state) => state.getMySongRequestsPending);
  const isSongbookWelcomeRead = songbookSessionStore((state) => state.isSongbookWelcomeRead);
  const setIsSongbookWelcomeRead = songbookSessionStore((state) => state.setIsSongbookWelcomeRead);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-songbook-theme", "dark");

  useEffect(() => {
    if (!theme || theme === "dark") {
      document.documentElement.classList.remove("light-theme");
    } else {
      document.documentElement.classList.add("light-theme");
    }
  }, []);

  const [isSongbookWelcomeOpen, setIsSongbookWelcomeOpen] = useState(true);
  const [welcomeHtml, setWelcomeHtml] = useState("");

  const [, updateState] = useState();

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem(muvikaAttrs.service + "-session-language");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  const handleCloseSongbookWelcome = () => {
    setIsSongbookWelcomeOpen(false);
    setIsSongbookWelcomeRead(true);
  };

  const handlePlayQueue = () => {
    if (settingsStore.getState().settings) {
      if (settingsStore.getState().settings?.sb_allow_playqueue_view == 1 && !isSongbookPublicMode) {
        getPlayQueue(sessionToken);
        getMySongRequestsDelivered(sessionToken);
        getMySongRequestsPending(sessionToken);
      }
    }
  };

  const handleLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    updateSession(sessionToken, lowLang);
    updateState({});
  };

  useEffect(() => {
    if (language.length > 0) {
      handleLanguageChange(language);
    }
    clearError();
    let interval = setInterval(handlePlayQueue, songbookIntervalTime);
    IntervalService.setSongbookPlayqueueInterval(interval);
    getSettings(sessionToken);
    var href = window.location.href;
    let hrefSplitted = href.split("?");
    if (hrefSplitted.length > 1) {
      href = hrefSplitted[0];
    }
    let songbookCode = queryParameters.get("songbook_code");
    let earlierSongbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
    if (songbookCode !== earlierSongbookCode) {
      //window.history.pushState('object', document.title, href);
    }
  }, []);

  useEffect(() => {
    handlePlayQueue();
  }, [settings]);

  useEffect(() => {
    console.log("sb", settings);
    if (session && settings) {
      if (isSongbookPublicMode) {
        setWelcomeHtml(TR.cm_welcome_to_songbook_public.replace("%USER%", session.account.office_name));
      } else if (isSongbookPublicBoothMode) {
        setWelcomeHtml(TR.cm_welcome_to_songbook_booth.replace("%USER%", session.account.office_name));
      } else if (session.account.tags.includes("consumer")) {
        setWelcomeHtml(TR.cm_welcome_to_songbook_public.replace("%USER%", session.account.office_name));
      } else {
        setWelcomeHtml(TR.cm_welcome_to_songbook_pro.replace("%USER%", session.account.office_name));
      }
    }
  }, [session, settings]);

  function resetStores() {
    accountStore.getState().reset();
    catalogStore.getState().reset();
    environmentStore.getState().reset();
    favoritesStore.getState().reset();
    messageStore.getState().reset();
    musicStore.getState().reset();
    musicPlayerStore.getState().reset();
    navigationStore.getState().reset();
    newsStore.getState().reset();
    homeStore.getState().reset();
    newTracksStore.getState().reset();
    performanceStore.getState().reset();
    playerStore.getState().reset();
    searchStore.getState().reset();
    songbookSessionStore.getState().reset();
    settingsStore.getState().reset();
    singersStore.getState().reset();
    songListStore.getState().reset();
    timeoutsStore.getState().reset();
    bgFiltersStore.getState().reset();
    bgStylesStore.getState().reset();
    bgPerformanceStore.getState().reset();
    bgSearchStore.getState().reset();
    bgPlaylistsStore.getState().reset();
    musicPlayerStore.getState().reset();
    
    IntervalService.clearSongbookInterval();
    IntervalService.clearSongbookPlayqueueInterval();
    IntervalService.clearNewTracksInterval();
  }

  const renderWelcome = () => {
    if (!isSongbookWelcomeRead) {
      return <SongbookWelcome
        open={isSongbookWelcomeOpen}
        welcomeHtml={welcomeHtml}
        onClose={handleCloseSongbookWelcome}
      />;
    }
  };

  const renderIfLoggedIn = () => {
    if (isSessionOpen && isLoggedIn) {
      return <ThemeProvider theme={darkTheme}>
        <Error isSongbook={true} />
        <Message isSongbook={true} />
        <CssBaseline />
        {renderWelcome()}
        <MediaQuery minDeviceWidth={720}>
          <SongbookLandscape />
        </MediaQuery>
        <MediaQuery maxDeviceWidth={720}>
          <SongbookPortrait />
        </MediaQuery>
      </ThemeProvider>;
    } else {
      resetStores();
      return <Navigate to="/songs" />;
    }
  };

  return (
    <div>
      {renderIfLoggedIn()}
    </div>
  );
}

export default SongbookApp;
